<div ng-bind-html="pdvCtrl.newdrug.recriteria"></div>